module.exports = __webpack_public_path__ + "img/EDOGE.1827b0dc.svg";